import { createStore } from '@stencil/store';

const dynamicBannerStore = createStore({
  data: undefined,
  question: undefined,
  invoked: false,
  isRefinement: false,
});

export default dynamicBannerStore;
